import { render, staticRenderFns } from "./joinusClass.vue?vue&type=template&id=6e287d46&scoped=true"
import script from "./joinusClass.vue?vue&type=script&lang=js"
export * from "./joinusClass.vue?vue&type=script&lang=js"
import style0 from "./joinusClass.vue?vue&type=style&index=0&id=6e287d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e287d46",
  null
  
)

export default component.exports